import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { MasterPlanLocation, PublicLocation } from "../../domain";
import { MasterPlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetMasterLocationByIdUsecase implements UseCase<string, MasterPlanLocation> {

  constructor(private readonly masterPlanRepository: MasterPlansRepository) {
  }

  execute(params: string): Observable<MasterPlanLocation> {
    return this.masterPlanRepository.getMasterLocationById(params);
  }

}
